(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/match-list-item.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/match-list-item.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.MatchListItem = Marionette.View.extend({
    tagName: 'li',
    className:
      'list-group-item maltipset-match-row row js-clickable2 clickable-list-group-item-default',
    modelEvents: {
      'change tipsInfoDataSet': 'render'
    },
    events: {
      click: 'matchClicked'
    },

    template: function(data) {
      return svs.maltipset.templates.match_list_item(data);
    },

    onRender: function() {
      if (!svs.core.detect.formfactor.mobile()) {
        this.$el.toggleClass(
          'selected',
          !_.isUndefined(this.model.get('isSelected')) &&
            this.model.get('isSelected') === true
        );
      }
    },

    matchClicked: function() {
      if (
        !svs.core.detect.formfactor.mobile() &&
        this.model.collection.matchChangeEnabled
      ) {
        this.model.collection.matchClicked(this.model);
      } else if (svs.core.detect.formfactor.mobile()) {
        var drawNumber = svs.maltipset.collections.draws.models[
          svs.maltipset.collections.draws.currentDrawIndex
        ].get('drawNumber');

        var selectedMatch = this.model;

        if (selectedMatch && drawNumber) {
          var url =
            '/' +
            drawNumber +
            '/' +
            selectedMatch.get('eventNumber');

          var eventDescription = selectedMatch
            .get('eventDescription')
            .replace(/ /g, '');
          url += '-' + svs.utils.url.encode(eventDescription);
          svs.maltipset.router.navigate(url, { trigger: true, replace: false });
        }
      }
    }
  });
})(Backbone, _, svs);


 })(window);